import { redirect } from 'redux-first-router'
import { showNotification } from '@/state/actions/notification'
import { notifyServerEditingEnded } from '@/state/actions/editing'
import { isAllowed } from './utils'
import { ROUTE_LOGIN, ROUTE_NEWSLETTERS_EDIT } from '@/state/types/routes'

export default {
  onBeforeChange: (dispatch, getState, action) => {
    const state = getState()
    const allowed = isAllowed(action.type, state)

    if (!allowed) {
      const action = redirect({ type: ROUTE_LOGIN })
      dispatch(action)
      dispatch(showNotification(0, 'You must be logged in to access Elovade Newsletter!'))
    }
    // User is leaving NL editing page
    if (state.location.type === ROUTE_NEWSLETTERS_EDIT && action.type !== ROUTE_NEWSLETTERS_EDIT) {
      dispatch(notifyServerEditingEnded(state.location.payload.id))
    }
  },
  onAfterChange: (dispatch, getState) => {
    // const { type } = getState().location
    // if (type === ROUTE_LOGIN) {
    //   setTimeout(() => {
    //     alert(alertMessage)
    //   }, 1500)
    // }
  },
}



// WEBPACK FOOTER //
// ./state/callbacks.js